var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticStyle:{"border":"3px solid red"}},[_c('Nuxt')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }